import { Injectable } from '@angular/core';
import { ICiapPaginado, ICidPaginado, IFilterCiapPaginado, IFilterCidPaginado } from 'src/app/model/terminologia';
import { BaseClientService } from './base-client.service';

@Injectable({
  providedIn: 'root'
})
export class TerminologiaService {

  constructor(private client: BaseClientService) { }

  async listaCiapPaginado(filter: IFilterCiapPaginado): Promise<ICiapPaginado> {
    
    return await this.client.post(`/ciap2/paginado`, filter).toPromise();
  }

  async listaCidPaginado(filter: IFilterCidPaginado): Promise<ICidPaginado> {
    return await this.client.post(`/cid10/paginado`, filter).toPromise();
  }
}
